import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, Textarea } from 'tdesign-react';
import Text from '@/components/Text';
import { addDict, updateDict } from '@/services/dictService';
import { isVoid } from '@/utils/common';

const { FormItem } = Form;

export default function FormModal({ visible, handleClose, detail }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const isEdit = !isVoid(detail);

  useEffect(() => {
    if (visible) {
      form.reset();
      if (isEdit) {
        setTimeout(() => form.setFieldsValue(detail), 50);
      }
    }
  }, [visible, form, isEdit, detail]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        if (isEdit) {
          await updateDict({
            ...fields,
            id: detail.id,
          });
        } else {
          await addDict(fields);
        }
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header={isEdit ? '修改字典' : '新增字典'}
      onClose={() => handleClose()}
      visible={visible}
      onConfirm={() => form.submit()}
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
      width={600}
    >
      <Form form={form} style={{ width: '90%' }} onSubmit={handleSubmit}>
        <FormItem name='dictKey' label='字典名称' rules={[{ required: true }]}>
          {isEdit ? <Text /> : <Input />}
        </FormItem>
        <FormItem name='dictValue' label='字典编码' rules={[{ required: true }]}>
          <Textarea placeholder='字典编码' rows={5} />
        </FormItem>
        <FormItem name='remark' label='备注' rules={[{ required: true }]}>
          <Textarea placeholder='备注' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
